
if(['/pages/registreren', '/account/register'].includes(window.location.pathname) || window.location.pathname.includes('/account/register')) {
const intervalTime = 100;
    const maxTime = 8000;
    let elapsedTime = 0;

    const intervalId = setInterval(() => {
        const form = document.querySelector("#country-name");

        if (form) {
            setTimeout(() => {
                handleCustomForm();
            }, 50);

            clearInterval(intervalId);
        }

        elapsedTime += intervalTime;

        if (elapsedTime >= maxTime) {
            clearInterval(intervalId);
        }
    }, intervalTime);
}

function handleCustomForm() {
    var EU_COUNTRIES = [
        "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
        "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
        "PL", "PT", "RO", "SK", "SI", "ES", "SE"
    ];

    var euVatField = getField("vat-validation");
    var ukVatField = getField("uk-validation");
    var gstField = getField("gst-validation");
    var abnField = getField("abn-validation");
    hideAllTaxFields();

    document.addEventListener("BSS:rf_change_country", function(e) {

        hideAllTaxFields();
        const countryCode = e.detail.country;
        console.log(countryCode)
        // UK
        if (countryCode === "GB") {
            show(ukVatField);
            return;
        }

        // EU
        if (EU_COUNTRIES.indexOf(countryCode) !== -1) {
            show(euVatField);
            return;
        }

        // India
        if (countryCode === "IN") {
            show(gstField);
            return;
        }

        // Australia
        if (countryCode === "AU") {
            show(abnField);
        }

    });

    function getField(inputId) {
        var input = document.getElementById(inputId);
        return input ? input.closest(".bss-b2b-rf-field") : null;
    }

    function hideAllTaxFields() {
        hide(euVatField);
        hide(ukVatField);
        hide(gstField);
        hide(abnField);
    }

    function hide(field) {
        if (!field) return;
        field.style.display = "none";
        var input = field.querySelector("input");
        if (input) input.value = "";
    }

    function show(field) {
        if (!field) return;
        field.style.display = "block";
    }
}



// Custom BSS Quote - Add to Quote Cart Page
function bssApplyR4qButtonColor(el) {
  if (!el.shadowRoot) return;
  if (el.shadowRoot.querySelector('style[data-bss-override]')) return;

  var style = document.createElement('style');
  style.setAttribute('data-bss-override', 'true');
  style.textContent = '.bcp-r4q-button-main { background-color: #FFE2AA !important; color: #000 !important }';
  el.shadowRoot.appendChild(style);
}

function bssOverrideR4qButtonColor() {
  document.querySelectorAll('bcp-r4q-button-main').forEach(bssApplyR4qButtonColor);
}

if (window.BSS_BCP_V2?.r4q?.logics?.length) {
  bssOverrideR4qButtonColor();

  var bssR4qObserver = new MutationObserver(function () {
    bssOverrideR4qButtonColor();
  });
  bssR4qObserver.observe(document.body, { childList: true, subtree: true });
}

// BSS: Quote form (New look) - apply the colors/radius set in Quote logic > Form styles.
// New look hard-codes white header + navy buttons, so inject overrides into the form shadow root.
function bssBuildR4qFormCss(s) {
  var r = (s.generalBorderRadius != null ? s.generalBorderRadius : 12) + 'px';
  return ':host(.new-look) .modal-header{background-color:' + s.headerBackgroundColor + ' !important;color:' + s.headerTextColor + ' !important;border-bottom:0 !important}' +
    ':host(.new-look) .modal-header .modal-title,:host(.new-look) .modal-header .modal-close{color:' + s.headerTextColor + ' !important}' +
    ':host(.new-look) .modal-header .modal-close:hover{background-color:rgba(255,255,255,.2) !important}' +
    ':host(.new-look) .button-primary{background-color:' + s.primaryButtonBackgroundColor + ' !important;border-color:' + s.primaryButtonBorderColor + ' !important;color:' + s.primaryButtonTextColor + ' !important;border-radius:' + r + ' !important}' +
    ':host(.new-look) .button-primary:hover:not([disabled]){background-color:' + s.primaryButtonBackgroundHoverColor + ' !important;border-color:' + s.primaryButtonBorderHoverColor + ' !important;color:' + s.primaryButtonTextHoverColor + ' !important}' +
    ':host(.new-look) .button-secondary{background-color:' + s.secondaryButtonBackgroundColor + ' !important;border-color:' + s.secondaryButtonBorderColor + ' !important;color:' + s.secondaryButtonTextColor + ' !important;border-radius:' + r + ' !important}' +
    ':host(.new-look) .button-secondary:hover:not([disabled]){background-color:' + s.secondaryButtonBackgroundHoverColor + ' !important;border-color:' + s.secondaryButtonBorderHoverColor + ' !important;color:' + s.secondaryButtonTextHoverColor + ' !important}';
}

function bssApplyR4qFormStyle(form) {
  var s = form.logic && form.logic.formStyles;
  if (!s || !form.shadowRoot) return;
  if (form.shadowRoot.querySelector('style[data-bss-form-override]')) return;

  var style = document.createElement('style');
  style.setAttribute('data-bss-form-override', 'true');
  style.textContent = bssBuildR4qFormCss(s);
  form.shadowRoot.appendChild(style);
}

function bssFindR4qForms(root, out) {
  root.querySelectorAll('*').forEach(function (el) {
    if (el.tagName === 'BCP-R4Q-FORM-MAIN') out.push(el);
    if (el.shadowRoot) bssFindR4qForms(el.shadowRoot, out);
  });
  return out;
}

if (window.BSS_BCP_V2?.r4q?.logics?.length) {
  // The form is rendered inside shadow DOM (body MutationObserver can't see it), so poll for it.
  setInterval(function () {
    document.querySelectorAll('bcp-r4q-form-wrapper').forEach(function (w) {
      if (w.shadowRoot) bssFindR4qForms(w.shadowRoot, []).forEach(bssApplyR4qFormStyle);
    });
  }, 500);
}
